import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { formatMoneyPerCountry } from '@spa/shared/utils/money';
import { MarkerContainer } from './styles';
import Heart from '@spa/shared/svg/heart';
import useClickedOffers from '@spa/shared/hooks/useClickedOffers';

const getMoney = (prices, currency, language, isUniresidences) => {
  const max = Math.max(...prices);
  const min = Math.min(...prices);
  const minFormated = formatMoneyPerCountry(min, currency, language, isUniresidences);

  return min === max
    ? minFormated
    : `${minFormated} - ${formatMoneyPerCountry(max, currency, language, isUniresidences)}`;
};

const Marker = ({
  offer,
  onClick,
  className,
  isOnWishList = false,
  handleWishlistButtonClick = () => {},
  isUniresidences
}) => {
  const {
    i18n: { language }
  } = useTranslation();
  const { currency, prices, count, id, version } = offer;
  const [hasBeenClicked, handleMarkerClick] = useClickedOffers(id, version, onClick);

  return (
    <MarkerContainer onClick={handleMarkerClick} className={`${className} ${hasBeenClicked ? 'marker--clicked' : ''}`}>
      {isOnWishList ? <Heart className="wishlist-button" active={true} onClick={handleWishlistButtonClick} /> : null}
      {getMoney(prices, currency, language, isUniresidences)}
      {count > 1 ? <span>{count}</span> : null}
    </MarkerContainer>
  );
};

Marker.propTypes = {
  offer: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  isOnWishList: PropTypes.bool,
  isUniresidences: PropTypes.bool,
  handleWishlistButtonClick: PropTypes.func
};

export default Marker;
